module.exports = __webpack_public_path__ + "img/channel_login_background.6de06238.jpeg";